import React from "react";
import { CircularProgress, Stack, Typography } from "@mui/material";
import useSubscriptionTab from "./SubscriptionTab.hook";
import AccountTeamSection from "./AccountTeamSection";
import TermRow from "./TermRow";
import SubscriptionEmptyState from "./SubscriptionEmptyState";
import SubscriptionErrorState from "./SubscriptionErrorState";

const SubscriptionTab = ({ accountId, isAccountContext, salesforceAccountId }) => {
  const { opportunities, teamMembers, interactionLimit, interactionDefinition, isLoading, isError, isEmpty } = useSubscriptionTab({
    accountId,
    isAccountContext,
    hasSalesforceId: !!salesforceAccountId
  });

  if (isLoading) {
    return (
      <Stack alignItems="center" justifyContent="center" sx={{ minHeight: 400 }}>
        <CircularProgress />
      </Stack>
    );
  }

  if (isError) {
    return <SubscriptionErrorState />;
  }

  if (isEmpty) {
    return <SubscriptionEmptyState />;
  }

  return (
    <Stack gap={3}>
      <AccountTeamSection teamMembers={teamMembers} />
      {opportunities.map((opportunity, index) => (
        <TermRow key={opportunity.name} opportunity={opportunity} index={index} interactionLimit={interactionLimit} interactionDefinition={interactionDefinition} />
      ))}
    </Stack>
  );
};

export default SubscriptionTab;
